import {
  BROWSER_LANGUAGE_TARGETING,
  CONTENT_TARGETING,
  CUSTOM_TARGETING,
  DEVICE_CATEGORY,
  DEVICE_MANUFACTURER_TARGETING,
  GEO_TARGETING,
  ENVIRONMENT_TYPE,
  LOGICAL_OPERATOR,
  OPERATING_SYSTEM_TARGETING,
  environmentTypes
} from '../fields'
import { formatInventoryTargeting } from './formatInventoryTargeting'

export const formatTargetingToBE = ({ inventory, values, right }) => {
  // Create technology_targeting object only if any technology targeting options are selected
  const hasTechnologyTargeting =
    values[DEVICE_CATEGORY]?.length > 0 ||
    values[BROWSER_LANGUAGE_TARGETING]?.length > 0 ||
    values[DEVICE_MANUFACTURER_TARGETING]?.length > 0 ||
    values[OPERATING_SYSTEM_TARGETING]?.length > 0

  return {
    inventory_targeting: formatInventoryTargeting({ inventory, right }),

    // Add custom_targeting only if custom_targeting values are selected and at least one key has values
    ...(values[CUSTOM_TARGETING]?.length > 0 &&
      values[CUSTOM_TARGETING].some(targeting => targeting.values?.length > 0) && {
        custom_targeting: {
          [LOGICAL_OPERATOR]: values[LOGICAL_OPERATOR],
          children: values[CUSTOM_TARGETING].filter(targeting => targeting.values?.length > 0) // Only include keys with values
            .map(targeting => ({
              xsi_type: 'CustomCriteria',
              keyId: targeting.id,
              valueIds: targeting.values.map(value => value.id || value.value),
              operator: targeting.operator
            }))
        }
      }),

    // Add content_targeting only if content_targeting values are selected
    ...(values[CONTENT_TARGETING]?.length > 0 && {
      content_targeting: {
        targeted_content_ids: values[CONTENT_TARGETING].map(content => content.id)
      }
    }),

    // Add geo_targeting only if geo_targeting values are selected
    ...(values[GEO_TARGETING]?.length > 0 && {
      geo_targeting: {
        targeted_locations: values[GEO_TARGETING].map(location => ({
          id: location.id
        }))
      }
    }),

    // Add technology_targeting only if any technology targeting options are selected
    ...(hasTechnologyTargeting && {
      technology_targeting: {
        // Add device_category_targeting only if device_category values are selected
        ...(values[DEVICE_CATEGORY]?.length > 0 && {
          device_category_targeting: {
            targeted_device_categories: values[DEVICE_CATEGORY].map(category => ({
              id: category.id
            }))
          }
        }),

        // Add browser_language_targeting only if browser_language_targeting values are selected
        ...(values[BROWSER_LANGUAGE_TARGETING]?.length > 0 && {
          browser_language_targeting: {
            browser_languages: values[BROWSER_LANGUAGE_TARGETING].map(language => ({
              id: language.id
            })),
            is_targeted: true
          }
        }),

        // Add device_manufacturer_targeting only if device_manufacturer_targeting values are selected
        ...(values[DEVICE_MANUFACTURER_TARGETING]?.length > 0 && {
          device_manufacturer_targeting: {
            device_manufacturers: values[DEVICE_MANUFACTURER_TARGETING].map(manufacturer => ({
              id: manufacturer.id
            })),
            is_targeted: true
          }
        }),

        // Add operating_system_targeting only if operating_system_targeting values are selected
        ...(values[OPERATING_SYSTEM_TARGETING]?.length > 0 && {
          operating_system_targeting: {
            operating_systems: values[OPERATING_SYSTEM_TARGETING].map(os => ({
              id: os.id
            })),
            is_targeted: true
          }
        })
      }
    }),

    ...(values[ENVIRONMENT_TYPE] === environmentTypes.VIDEO_PLAYER && {
      request_platform_targeting: {
        targeted_request_platforms: ['BROWSER', 'MOBILE_APP']
      }
    })
  }
}
